// Construcția payload-ului de import, extrasă din `NcrmContacts.vue`.
//
// Cele trei apeluri către backend — preview headers, preview mapped și execute —
// repetau aceleași `formData.append`. Extragerea a fost cerută de quality gate
// când pasul de proveniență (DPIA A3 / B1) a mărit din nou un fișier deja peste
// buget, dar elimină și triplicarea, care era o sursă reală de divergență: o
// opțiune adăugată doar în două din trei locuri produce un preview care nu
// seamănă cu importul executat.

export const normalizeLegacyReferencePrefix = (value) => {
  const normalized = String(value || "").trim();
  if (!normalized) return "";
  return normalized.replace(/:+$/g, "");
};

const appendLegacyReferencePrefix = (formData, { legacyReferencePrefix }) => {
  const normalized = normalizeLegacyReferencePrefix(legacyReferencePrefix);
  if (!normalized) return;
  formData.append("legacyReferencePrefix", normalized);
};

const appendActivityConfig = (formData, state) => {
  if (state.importType !== "activity") return;
  formData.append("activityTargetEntityType", state.activityTargetEntityType);
  formData.append("activityMatchSourceColumn", state.activityMatchSourceColumn);
  formData.append("activityMatchInternalField", state.activityMatchInternalField);
  formData.append("activityDedupeSourceColumn", state.activityDedupeSourceColumn);
  formData.append("activityDedupeInternalField", state.activityDedupeInternalField);
};

const appendContactMatchConfig = (formData, state) => {
  if (!["company", "person"].includes(state.importType)) return;
  if (state.contactMatchSourceColumn) {
    formData.append("contactMatchSourceColumn", state.contactMatchSourceColumn);
  }
  if (state.contactMatchInternalField) {
    formData.append("contactMatchInternalField", state.contactMatchInternalField);
  }
};

// DPIA A3 / B1 — proveniența. `undocumented` este trimis explicit, nu omis:
// backendul refuză o cerere fără răspuns, iar un câmp lipsă ar fi indistinct de
// un client vechi care nu știe să întrebe.
const appendProvenance = (formData, { importProvenance }) => {
  const provenance = importProvenance || {};
  formData.append("sourceCategory", provenance.sourceCategory || "undocumented");
  const description = String(provenance.sourceDescription || "").trim();
  if (description) formData.append("sourceDescription", description);
  if (provenance.subjectsAlreadyInformed) formData.append("subjectsAlreadyInformed", "true");
};

// `includeProvenance` este fals pentru preview: acolo nu se scrie nimic, deci
// întrebarea nu a fost încă pusă operatorului.
export const appendImportConfig = (formData, state, { includeProvenance = false } = {}) => {
  if (!formData || typeof formData.append !== "function") return formData;
  appendLegacyReferencePrefix(formData, state);
  appendActivityConfig(formData, state);
  appendContactMatchConfig(formData, state);
  if (includeProvenance) appendProvenance(formData, state);
  return formData;
};
